import { tns } from 'tiny-slider/src/tiny-slider'

function createSlider (container, navContainer) {
  return tns({
    container,
    navContainer,
    autoHeight: true,
    controls: false,
    loop: false
  })
}

const sliders = document.querySelectorAll('.js-slider')

for (let i = 0; i < sliders.length; i++) {
  const container = sliders[i].querySelector('.js-slider-container')
  const navContainer = sliders[i].querySelector('.js-slider-nav')

  createSlider(container, navContainer)
}
